module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-lights",
    attrs: {
      "id": "light-log"
    }
  }, [_c('div', {
    staticClass: "panelheader border-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('div', {
    staticClass: "log_lights"
  }, [
    [_c('vuetable', {
      ref: "vuetable",
      attrs: {
        "api-url": "/api/logs/lights",
        "http-options": _vm.header,
        "fields": _vm.columns,
        "per-page": 10,
        "pagination-path": ""
      },
      on: {
        "vuetable:pagination-data": _vm.onPaginationData
      },
      scopedSlots: _vm._u([{
        key: "turned_on",
        fn: function(props) {
          return [(props.rowData.turned_on == 'On') ? _c('div', [_c('el-tag', {
            attrs: {
              "type": "success"
            }
          }, [_vm._v(_vm._s(props.rowData.turned_on))])], 1) : _c('div', [_c('el-tag', {
            attrs: {
              "type": "danger"
            }
          }, [_vm._v(_vm._s(props.rowData.turned_on))])], 1)]
        }
      }])
    }), _vm._v(" "), _c('div', {
      staticClass: "vuetable-pagination ui basic segment grid"
    }, [_c('vuetable-pagination-info', {
      ref: "paginationInfo"
    }), _vm._v(" "), _c('vuetable-pagination', {
      ref: "pagination",
      on: {
        "vuetable-pagination:change-page": _vm.onChangePage
      }
    })], 1)]
  ], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c66fac62","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/LightsTable.vue
// module id = 954
// module chunks = 26